import type { VcfStatus } from "../types";

export const VCF_STATUS: VcfStatus = {
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
  IN_PROGRESS: "IN_PROGRESS",
  NONE: "NONE",
  SEARCH_INDEX: "SEARCH_INDEX",
};
